var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 22.06 25.336",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_748",
    "data-name": "\\u7EC4 748",
    transform: "translate(-1718.94 -1047.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_747",
    "data-name": "\\u7EC4 747"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_344",
    "data-name": "\\u8DEF\\u5F84 344",
    d: "M1737.3,1047.262c.2.046.4.087.6.139a4.143,4.143,0,0,1-.461,8.11,4.053,4.053,0,0,1-3.438-1.092c-.067-.061-.131-.124-.2-.186a.228.228,0,0,0-.046-.02l-6.8,4.212a4.215,4.215,0,0,1,0,3.01l6.81,4.218c.14-.126.276-.256.419-.376a4.145,4.145,0,1,1,3.253,7.277.787.787,0,0,0-.137.044h-.891a10.36,10.36,0,0,1-1.291-.391,4.1,4.1,0,0,1-2.223-4.991.3.3,0,0,0-.156-.426q-3.211-1.971-6.411-3.964c-.048-.03-.1-.057-.167-.1a4.14,4.14,0,0,1-3.715,1.3,3.987,3.987,0,0,1-2.574-1.483,4.124,4.124,0,0,1,.351-5.607,4.172,4.172,0,0,1,5.946.2l.831-.515q2.9-1.8,5.8-3.588a.22.22,0,0,0,.113-.313,4.136,4.136,0,0,1,3.38-5.414.6.6,0,0,0,.115-.04Zm-.46,23.819a2.632,2.632,0,1,0-2.623-2.65A2.631,2.631,0,0,0,1736.843,1071.081Zm.011-22.3a2.632,2.632,0,1,0,2.628,2.647A2.622,2.622,0,0,0,1736.854,1048.779Zm-16.394,11.156a2.632,2.632,0,1,0,2.613-2.634A2.623,2.623,0,0,0,1720.46,1059.935Z",
    fill: "currentColor"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareOutlined);
export default __webpack_public_path__ + "static/media/share_outlined.7236f062.svg";
export { ForwardRef as ReactComponent };